<script setup>
  import indexInfo from './../components/index/indexInfo.vue';
  import indexExtras from './../components/index/indexExtras.vue';
</script>
<template>
  <indexInfo />
  <indexExtras />
</template>